import { NavLink } from "react-router-dom";

import classes from "./StyledLink.module.css";

const StyledLink = ({ to, children }) => {
  return (
    <NavLink to={to} className={classes.link}>
      {children}
    </NavLink>
  );
};

export default StyledLink;
